import script from "./DashboardSiteSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSiteSupport.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSiteSupport.vue?vue&type=style&index=0&id=5b9de7e1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9de7e1"]])

export default __exports__